import styled from 'styled-components';

import Avatar, { AvatarVariant } from '../../../../../../../../../components/Avatar';
import { ThemeProp } from '../../../../../../../../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  height: 4rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c200};
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  border-radius: 0.5rem;
  padding: 1rem;
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  cursor: pointer;
  flex: 1;
  max-height: 4rem;

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.main.c050};
    border: 1px solid ${(props: ThemeProp) => props.theme.colors.main.c100};
  }

  font-size: ${({ theme }: ThemeProp) => theme.fontVariants.desktop.body2.fontSize};
  line-height: ${({ theme }: ThemeProp) => theme.fontVariants.desktop.body2.lineHeight};
`;

export const AvatarImage = styled(Avatar).attrs(() => ({
  variant: AvatarVariant.MEDIUM,
}))``;

export const ConnectionLabel = styled.span`
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  line-height: ${({ theme }: ThemeProp) => theme.lineHeight.xs};
  font-style: italic;
  color: ${({ theme }: ThemeProp) => theme.colors.content.subdued.high};
  margin-left: auto;
`;

export const OrganizationName = styled.span`
  max-width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
